import styled from 'styled-components'
import Button from '../../../Button'

export default styled(Button)`
  margin-left: 5px;
  width: 50px;
`
